import 'magnific-popup';

$('.js_picture_show').on('click', event => {
  const id = $(event.target).data('id');
  createShowPicturePopUp(id);
});

const createShowPicturePopUp = (pictureId) =>{
  $.ajax({
    url: '/popup_picture_show/' + pictureId,
    type: 'GET',
    success: function(html) {
      $('#popup').html(html);

      $.magnificPopup.open({
        items: {src: '#popup'},
        type: 'inline',
        fixedContentPos: true,
      }, 0);

      $(document).on('click', '.back', function (e) {
        e.preventDefault();
        $.magnificPopup.close();
      });
    },
    error: function(e) {
      console.error(e);
      alert('ポップアップの作成に失敗しました');
    }
  });
};
